__turbopack_context__.v({
  "asterisk": "calculatorIntro-module-scss-module__6RhEQG__asterisk",
  "intro": "calculatorIntro-module-scss-module__6RhEQG__intro",
  "reference": "calculatorIntro-module-scss-module__6RhEQG__reference",
  "referenceAsterisk": "calculatorIntro-module-scss-module__6RhEQG__referenceAsterisk",
  "text": "calculatorIntro-module-scss-module__6RhEQG__text",
  "title": "calculatorIntro-module-scss-module__6RhEQG__title",
  "titleBold": "calculatorIntro-module-scss-module__6RhEQG__titleBold",
  "titleText": "calculatorIntro-module-scss-module__6RhEQG__titleText",
});
